import { render, staticRenderFns } from "./product.vue?vue&type=template&id=509148f6"
import script from "./product.vue?vue&type=script&lang=ts"
export * from "./product.vue?vue&type=script&lang=ts"
import style0 from "./product.vue?vue&type=style&index=0&id=509148f6&prod&lang=css"
import style1 from "./product.vue?vue&type=style&index=1&id=509148f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports